/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Tracker_Type_Anychange1Inputs */

const he_extension_tracker_type_anychange1 = /** @type {(inputs: Extension_Tracker_Type_Anychange1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`כל שינוי`)
};

const en_extension_tracker_type_anychange1 = /** @type {(inputs: Extension_Tracker_Type_Anychange1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Any change`)
};

/**
* | output |
* | --- |
* | "Any change" |
*
* @param {Extension_Tracker_Type_Anychange1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_tracker_type_anychange1 = /** @type {((inputs?: Extension_Tracker_Type_Anychange1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Tracker_Type_Anychange1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_tracker_type_anychange1(inputs)
	return en_extension_tracker_type_anychange1(inputs)
});
export { extension_tracker_type_anychange1 as "extension_tracker_type_anyChange" }